import script from "./ProductMetaContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductMetaContainer.vue?vue&type=script&setup=true&lang=ts"

import "./ProductMetaContainer.vue?vue&type=style&index=0&id=91ad7b48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91ad7b48"]])

export default __exports__